import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./navigationItem.module.scss";

const NavigationItem = (props) => {
  const { title, link } = props.content;
  const { onRouteSwither } = props;
  
  return (
    <NavLink
      to={link}
      className={styles.navigationItem}
      activeClassName={styles.navigationItem_active}  
    >
      {title}
    </NavLink>
  );
};

export default React.memo(NavigationItem);
